module.exports = __webpack_public_path__ + "static/apple-touch-icon-993dfd33d90b4839b5cf1cb35c0f228d.png";